import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

export default function TermDeleteDialog({ open, termDescription, onCancel, onConfirm }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Excluir termo</DialogTitle>
      <DialogContent dividers>
        <Typography>
          O termo {termDescription ? `"${termDescription}"` : 'selecionado'} será removido e deixará
          de ficar disponível para gerar documentos dos pacientes. Deseja continuar?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancelar</Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
}

TermDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  termDescription: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

TermDeleteDialog.defaultProps = {
  termDescription: '',
};
